'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useInitiatives } from '@/lib/hooks/useInitiatives';
import { InitiativeCard } from '@/components/initiatives/InitiativeCard';
import type { InitiativesQuery } from '@/lib/api/types';
interface ThemeInitiativesProps {
  /** Section heading */
  title: string;
  /** Section subtitle */
  subtitle?: string;
  /** Filter initiatives by categories */
  categories?: string[];
  /** Filter initiatives by type */
  type?: string[];
  /** Filter initiatives by tags */
  tags?: string[];
  /** Filter initiatives by activities */
  activities?: string[];
  /** Filter initiatives by themes */
  themes?: string[];
  /** Max number of initiatives to show */
  limit?: number;
}
export function ThemeInitiatives(t0) {
  const $ = _c(36);
  const {
    title,
    subtitle,
    categories,
    type,
    tags,
    activities,
    themes,
    limit: t1
  } = t0;
  const limit = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== activities || $[1] !== categories || $[2] !== limit || $[3] !== tags || $[4] !== themes || $[5] !== type) {
    t2 = {
      status: "active",
      visibility: "public",
      isTemplate: false,
      categories,
      context: "theme-featured-initiatives",
      type,
      tags,
      activities,
      themes,
      limit
    };
    $[0] = activities;
    $[1] = categories;
    $[2] = limit;
    $[3] = tags;
    $[4] = themes;
    $[5] = type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const query = t2;
  const {
    data,
    isLoading
  } = useInitiatives(query);
  let t3;
  bb0: {
    if (!data?.pages) {
      let t4;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[8] !== data.pages || $[9] !== limit) {
      t4 = data.pages.flatMap(_temp).slice(0, limit);
      $[8] = data.pages;
      $[9] = limit;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = t4;
  }
  const initiatives = t3;
  if (isLoading) {
    let t4;
    if ($[11] !== title) {
      t4 = <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h3>;
      $[11] = title;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[13] !== subtitle) {
      t5 = subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>;
      $[13] = subtitle;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== t4 || $[16] !== t5) {
      t6 = <div className="mb-8">{t4}{t5}</div>;
      $[15] = t4;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{[...Array(3)].map(_temp2)}</div>;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== t6 || $[20] !== t7) {
      t8 = <section className="py-12 sm:py-16"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t6}{t7}</div></section>;
      $[19] = t6;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    return t8;
  }
  let t4;
  if ($[22] !== title) {
    t4 = <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h3>;
    $[22] = title;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== subtitle) {
    t5 = subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>;
    $[24] = subtitle;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t4 || $[27] !== t5) {
    t6 = <div className="mb-8">{t4}{t5}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== initiatives) {
    t7 = initiatives.map(_temp3);
    $[29] = initiatives;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t7) {
    t8 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{t7}</div>;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== t6 || $[34] !== t8) {
    t9 = <section className="py-12 sm:py-16"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t6}{t8}</div></section>;
    $[33] = t6;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
}
function _temp3(initiative) {
  return <InitiativeCard key={initiative.id} initiative={initiative} />;
}
function _temp2(_, i) {
  return <div key={i} className="animate-pulse bg-white rounded-2xl overflow-hidden shadow-sm"><div className="h-[240px] bg-gray-200" /><div className="p-5"><div className="h-4 bg-gray-200 rounded w-1/4 mb-3" /><div className="h-6 bg-gray-200 rounded w-3/4 mb-4" /><div className="h-4 bg-gray-200 rounded w-full mb-2" /></div></div>;
}
function _temp(page) {
  return page.initiatives;
}